import React from "react";
import styled, { css } from "styled-components";
import { ReactComponent as InfoSvg } from "../../../svg/info.svg";

export const NotificationContainer = styled.div`
  animation: ${css`
   fadeInAnim 500ms 1 forwards
  `};
  animation: ${(p) =>
    p.fadeOut
      ? css`
   fadeOutAnim 333ms 1 forwards
  `
      : null};
  position: absolute;
  top: 30px;
  display: flex;
  align-items: center;
  width: 100%;
  background: #ffb000;
  color: #7f3da5;
  border-radius: 10px;
  padding: 18px;
  /* max-width: 260px;
  max-width: 120px; */
  max-width: 315px;
  right: 50%;
  font-size: 12px;
  transform: translateX(50%) translateY(-100px);
  z-index: 4;
  p {
    width: 80%;
    padding: 20px;
    text-transform: none;
  }
  & > svg {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }

  @keyframes fadeOutAnim {
    0% {
      transform: translateX(50%) translateY(0);
      opacity: 1;
    }
    25% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      transform: translateX(50%) translateY(-120px);
      opacity: 0;
    }
  }
  @keyframes fadeInAnim {
    0% {
      animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.93);
      transform: translateX(50%) translateY(-120px);
      opacity: 0;
    }
    50% {
      animation-timing-function: cubic-bezier(0.29, 0.14, 0.62, 1);
      transform: translateX(50%) translateY(20px);
      opacity: 1;
    }
    100% {
      transform: translateX(50%) translateY(0);
      opacity: 1;
    }
  }
`;
export const NotificationIcon = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #7f3da5;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const NotificationFrame = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Scaling = styled.div`
  position: relative;
  height: 607px;
  min-height: 607px;
  width: 315px;

  @media only screen and (max-height: 667px) {
    transform: scale(${(p) => p.h / 667});
  }
`;
export const Icon = () => {
  return (
    <NotificationIcon>
      <InfoSvg />
    </NotificationIcon>
  );
};
